import api, { ResponsePayloadWithData } from '.';

export type ContentTypeSummary = {
  id: string;
  name: string;
  usage: number;
};

export type ExerciseCategory = {
  id: string;
  name: string;
  usage: number;
  score?: {
    maximum: number;
    achievable: number;
    achieved: number;
  };
  categories?: ExerciseCategory[];
  completedExercises?: number;
  totalExercises: number;
  contentTypeSummary?: ContentTypeSummary[];
};

export const getExerciseCategories = async ({
  moduleId,
  includeScore = false,
  includeSubModules = false,
  includeCompletedExercises = false,
}: {
  moduleId: string;
  includeScore?: boolean;
  includeSubModules?: boolean;
  includeCompletedExercises?: boolean;
}) => {
  const { data } = await api.get<ResponsePayloadWithData<ExerciseCategory[]>>(
    `/studio/modules/${moduleId}/exercise-categories/usage`,
    {
      params: {
        includeScore,
        includeSubModules,
        ...(includeCompletedExercises && { includeCompletedExercises }),
      },
    },
  );

  return data;
};
